module.exports = __webpack_public_path__ + "img/step-1.f56f5d92.jpg";